import React from 'react';
import { useLocation, useHistory, Link } from 'react-router-dom';
import { Breadcrumb, Row, Col } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import MenuState from './Container';
import { conversionBreadcrumbList } from './BreadDeal';

const BreadMenuAndTitle = () => {
    const location = useLocation();
    const history = useHistory();
    const breadcrumbNameMap = MenuState.useContainer().breadMenu;
    const renderRouter = conversionBreadcrumbList({
        breadcrumbNameMap,
        location,
    });

    const routers: any = renderRouter.routes;
    const hasComponentRouter = routers.filter((item: any) => item.hasComponent);
    // @ts-ignore
    const gobackArrow = history.length > 1 && routers.length > 2 && hasComponentRouter.length >= 2;

    const goback = () => {
        gobackArrow && history.go(-1);
    };
    const pathname = location['pathname'];
    const getView = (item:any) => {
        const path = item.path;
        const hasComponent = item.hasComponent;
        const breadcrumbName = item.breadcrumbName;
        return (
            <Breadcrumb.Item key={path}>
                {hasComponent && path !== pathname ? (
                    <Link to={path}>{breadcrumbName}</Link>
                ) : (
                    breadcrumbName && <span>{breadcrumbName}</span>
                )}
            </Breadcrumb.Item>
        );
    };

    return (
        <Row className="breadCrumbView">
            <Col
                span={10}
                className="breadTitle"
                onClick={goback}
            >
                <span className={gobackArrow ? 'gobackTitle' : ''}>
                    {gobackArrow && <LeftOutlined />}
                    {routers[routers.length - 1] && routers[routers.length - 1]['breadcrumbName']}
                </span>
            </Col>
            <Col
                span={14}
                className="breadcrumbCol"
            >
                <Breadcrumb className="breadcrumb">
                    {routers &&
                        routers.map((item: any) => {
                        	return getView(item);
                        })}
                </Breadcrumb>
            </Col>
        </Row>
    );
};

export default BreadMenuAndTitle;
